import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=c7fb825c&scoped=true"
import script from "./FormBlock.vue?vue&type=script&lang=ts"
export * from "./FormBlock.vue?vue&type=script&lang=ts"
import style0 from "./FormBlock.vue?vue&type=style&index=0&id=c7fb825c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fb825c",
  null
  
)

export default component.exports